import { deserialize, getIframe } from '../../helpers';
import { isEmpty } from '../../utils/common';

const EnterPwd = {
  render: async () => {
    const state = history.state;
    sessionStorage.setItem('CONPAY_NEXT_HASH', state.nextHash);
    if (state?.nextState) {
      sessionStorage.setItem(
        'CONPAY_NEXT_STATE',
        JSON.stringify(state.nextState)
      );
    }

    return '';
  },
  afterRender: async () => {
    const state = history.state;
    const apiKey = sessionStorage.getItem('CONPAY_API_KEY');
    const data = deserialize(sessionStorage.getItem('CONPAY_COMPLETE_INFO'));

    if (
      state.mode === 'PIN_CHECK' &&
      data != undefined &&
      data != null &&
      !isEmpty(data.rsvdno) &&
      isEmpty(data.trDiv)
    ) {
      getIframe().location.replace(
        `${process.env.KEYPAD_URL}?mode=${
          state.mode
        }&apiKey=${encodeURIComponent(apiKey)}&rsvdno=${encodeURIComponent(
          data.rsvdno
        )}`
      );
    } else if (
      state.mode === 'PIN_CHECK' &&
      data != undefined &&
      data != null &&
      !isEmpty(data.rsvdno) &&
      !isEmpty(data.trDiv)
    ) {
      getIframe().location.replace(
        `${process.env.KEYPAD_URL}?mode=${
          state.mode
        }&apiKey=${encodeURIComponent(apiKey)}&rsvdno=${encodeURIComponent(
          data.rsvdno
        )}&trDiv=${encodeURIComponent(data.trDiv)}`
      );
    } else {
      getIframe().location.replace(
        `${process.env.KEYPAD_URL}?mode=${
          state.mode
        }&apiKey=${encodeURIComponent(apiKey)}`
      );
    }
  },
};
export default EnterPwd;
